import React, { useRef, useEffect } from "react";
import { Grid, Box } from "@mui/material";
import QuestionButton from "./QuestionButton";
import { useQuestionSection } from "../../../hooks/iit/useQuestionSection";

const QuestionGrid = ({
  questions,
  setCurrentQuestion,
  currentQuestion,
  questionData,
  subjectId,
}) => {
  const boxRef = useRef(null);
  const questionRefs = useRef([]);

  const { handleButtonClick } = useQuestionSection({
    questionData,
    currentQuestion,
    setCurrentQuestion,
    subjectId,
  });

  // Scroll to current question when it changes
  useEffect(() => {
    if (
      currentQuestion >= 0 &&
      questionRefs.current[currentQuestion] &&
      boxRef.current
    ) {
      const questionElement = questionRefs.current[currentQuestion];
      const boxElement = boxRef.current;

      // Calculate positions
      const boxRect = boxElement.getBoundingClientRect();
      const questionRect = questionElement.getBoundingClientRect();

      // Calculate scroll position
      const scrollPosition =
        questionRect.top -
        boxRect.top +
        boxElement.scrollTop -
        boxRect.height / 2 +
        questionRect.height / 2;

      // Smooth scroll
      boxElement.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  }, [currentQuestion]);

  return (
    <Box
      ref={boxRef}
      sx={{
        height: "100%",
        overflowY: "auto",
        "&::-webkit-scrollbar": {
          width: "0px",
        },
      }}
    >
      <Grid container spacing={1}>
        {questions?.map((q, idx) => (
          <Grid
            item
            xs={4}
            sm={4}
            md={4}
            key={q.number}
            ref={(el) => (questionRefs.current[idx] = el)}
          >
            <div
              // onClick={() => setCurrentQuestion(idx)}
              onClick={() => handleButtonClick(idx,q.id)}
              style={{ cursor: "pointer" }}
            >
              <QuestionButton
                // type={(currentQuestion===idx?'active':q.status)}
                type={q.status}
                number={q.number.toString().padStart(2, "0")}
                active={currentQuestion === idx}
              />
            </div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default QuestionGrid;
